module.exports = __webpack_public_path__ + "img/profile-woman-4-min.1b57956d.jpg";